// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['styleselect undo redo  fontsizeselect forecolor backcolor bold italic underline strikethrough alignleft aligncenter alignright alignjustify outdent indent  blockquote  removeformat code', 'subscript superscript  codesample hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons ']

export default toolbar



// WEBPACK FOOTER //
// ./src/components/Tinymce/toolbar.js